<template>
  <section class="margin-top-s">
    <div v-if="diffSalesTrack > 0" class="flex w100" style="padding-top: 4px; padding-bottom: 4px;">
        <p><b>Atenção:</b> {{ diffSalesTrack | number }} vendas sem <b>TRACKEAMENTO</b>. Confira se a configuração de UTMS está correta.</p>
    </div>
    <div v-if="adGroupFilter && adGroupFilter.length > 0" class="flex middle w100">
      <div class="flex-3 flex middle">
        <div class="button secondary small" @click="cleanAdgSelect()">Limpar Seleção</div>
      </div>
    </div>
    <!-- Barra de rolagem superior -->
    <div class="scrollbar-top">
        <div class="scroll-content"></div>
    </div>
    <div class="box adgroups">
      <div class="box-content">
        <ul class="list-itens"  :class="{item10: isMax10, item20: isMax20,  item30: isMax30,  }">
          <li>
            <div class="flex between">
              <div class="flex-3 elem-name">
                  <b>Nome do Conjunto de Anúncio</b>
              </div>
              <div class="elem-first-stats flex-1 txt-center">
                  <b>Orçamento</b>
              </div>
              <div 
                v-for="(item, k) in columnsOrder"
                :key="k"
                v-show="columns[item.name]"
                class="flex-1 txt-center"
              >
                <b>{{ item.label }}</b>
                <span class="info tooltip" v-if="item.tooltip">
                    <span class="tooltiptext">{{ item.tooltip }}</span>
                </span>
              </div>
            </div>
          </li>
          
          <li v-for="(adg, index) in adgroups" :key="index" class="flex middle w100">
            <div class="flex middle w100" :class="{selected: adg.selected}">
              <!-- name -->
              <div class="flex-3 elem-name flex middle" :class="{selected: adg.selected}">
                <div class="flex middle">
                  <div class="flex middle">
                    <input type="checkbox"  v-model="adg.selected" @change="changeSelectedAdg(adg)"/>
                  </div>
                  <div style="margin-left: 8px">
                    <m-switch
                         v-model="adg.status"
                        @change="showModalSwitchStatus=true;selectedAdGroup=adg;"
                    ></m-switch>
                  </div>
                  <div class="name" style="margin-left: 8px">
                    <i
                      v-if="adg.platform === 'FBADS'"
                      class="fa fa-facebook-square fbads"
                    ></i>
                    <i
                      v-if="adg.platform === 'GADS'"
                      class="fab fa-google gads"
                    ></i>
                    {{ adg.name | protect }}
                  </div>
                </div>
              </div>
              <!-- orçamento -->
              <div class="elem-first-stats flex-1 txt-center">
                <div v-if="adg.type === 'ABO'" class="flex center">
                  <money 
                    class="flex input"
                    style="max-width: 100px"
                    v-model="adg.daily_budget"
                    v-bind="money"
                    :disabled="true">
                  </money>
                  <div class="button secondary edit-money" @click="selectedAdGroup=adg;showUpdateModal=true">
                    <i class="fas fa-edit"></i>
                  </div>
                </div>
                <div v-else style="min-width: 183px;">
                  CBO
                </div>
              </div>
              <div 
                v-for="(item, k) in columnsOrder"
                :key="k"
                v-show="columns[item.name]"
                class="flex-1 txt-center"
              >
                <div v-if="['roas', 'profit', 'profit_value'].includes(item.name)">
                  <!-- roas -->
                  <div  v-if="item.name == 'roas'" class="flex-1 txt-center">
                      <span  class="tag" :class="{ negative:  getValueC('roas', adg.id) < 1, positive:  getValueC('roas', adg.id) >= 1 }" >
                        {{ getValueC('roas', adg.id) | number }}x
                      </span>
                  </div>
                  <!-- profit -->
                  <div  v-if="item.name == 'profit'" class="flex-1 txt-center">
                      <span  class="tag" :class="{ negative:  getValueC('profit', adg.id) <= 0, positive:  getValueC('profit', adg.id) > 0 }" >
                        {{ getValueC('profit', adg.id) | number }}%
                      </span>
                  </div>
                  <!-- profit_value -->
                  <div  v-if="item.name == 'profit_value'" class="flex-1 txt-center">
                      <span  class="tag" :class="{ negative:  getValueC('profit_value', adg.id) <= 0, positive:  getValueC('profit_value', adg.id) > 0 }" >
                        {{ getValueC('profit_value', adg.id) | money }}
                      </span>
                  </div>
                </div>
                <div v-else>
                  <span v-if="item.filter && item.filter=='money'" >
                    {{  getValueC(item.name, adg.id) | money }}<span v-if="item.suffix">{{ item.suffix }}</span>
                  </span>
                  <span v-else>
                    {{  getValueC(item.name, adg.id) | number }}<span v-if="item.suffix">{{ item.suffix }}</span>
                  </span>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div v-if="loading">
          <content-loading>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
          </content-loading>
        </div>
      </div>
    </div>

    <div class="flex-1 flex row w100 middle">
      <div class="flex w100 center filters-groupo-holder">
        <div class="flex between middle">
            <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
            ></paginate>
          </div>
      </div>
    </div>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalSwitchStatus"
      description="Você tem certeza que deseja alterar o Status?"
      @cancel="
        selectedAdGroup.status = !selectedAdGroup.status;
        showModalSwitchStatus = false;
        selectedAdGroup = null;
      "
      @accept="changeStatusAdGroup(selectedAdGroup)"
    ></modal-confirm>

    <modal
        title="Editar Orçamento"
        :show="showUpdateModal"
        @close="showUpdateModal=false;selectedAdGroup=null"
      >
        <div class="content flex " slot="content">
          <div class="flex column w100">
            <form v-if="selectedAdGroup" autocomplete="off" class="w100">
              <div class="flex-1 w100 margin-top-m">
                Conjunto: {{ selectedAdGroup.name }}
              </div>
              <div class="flex-1 w100 margin-top-m">
                <label>Orçamento:</label>
                <money v-model="selectedAdGroup.daily_budget" v-bind="money"></money>
              </div>
            </form>
            <div class="flex w100 center margin-top-l">
              <div class="button secondary" @click="showUpdateModal=false;selectedAdGroup=null">CANCELAR</div>
              <div class="button primary" @click="changeBulletAdGroup(selectedAdGroup)" style="margin-left: 8px">SALVAR</div>
            </div>
          </div>
        </div>
    </modal>
  </section>
</template>

<script>
import MSwitch from "@/components/MSwitch.vue";
import ModalConfirm from "@/components/modal/ModalConfirm";
import Modal from "@/components/modal/Modal";

import { Money } from 'v-money'

import {
  getAdGroupsFacebook,
  getAdGroupsGoogle,
  updateStatusFBADS,
  updateStatusGADS,
  updateBulletFBADS,
  updateBulletGADS
} from "@/services/campaigns";

import {
  getReportCampaigns,
} from "@/services/campaignsReport";

import { mapState } from "vuex";


export default {
  name: "ad-group",
  components: {
    MSwitch,
    ModalConfirm,
    Money,
    Modal
  },
  props: [
    'filters',
    'columns',
    'columnsOrder',
    'campaignsFilter',
    'adGroupFilter',
    'accountsFilter',
  ],
  data() {
    return {
      loading: false,
      showModalSwitchStatus: false,
      showUpdateModal: false,
      selectedAdGroup: null,
      reportAdGroups: {},
      stats: {},
      adgroups: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      totalItens: 0,
      offset: 20,
      page: 1,
    };
  },
  mounted() {

    if (!this.campaignsFilter || (this.campaignsFilter && this.campaignsFilter.length === 0)) {
      this.$toast.error({
        title:'Erro',
        message:'Selecione ao menos uma campanha'
      })
      this.$router.push({ name: 'CampaignDash', params: {slug: 'campaign'} })
    }

    this.getAllAdGroups();

    this.getReportAdgs();

    this.syncScrools()


    this.auxFilters = this.filters
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    totalPages() {
      let valueMode = this.totalItens % this.offset;
      let value = this.totalItens / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
    diffSalesTrack() {
      if (!this.stats.sales) {
        return 0
      }

      return this.stats.sales - this.stats.lh_sales
    },
    isMax10() {
      if (!this.columns) return false
      return Object.values(this.columns).reduce((acc, v) => acc + (v === true ? 1 : 0), 0) > 10;
    },
    isMax20() {
      if (!this.columns) return false
      return Object.values(this.columns).reduce((acc, v) => acc + (v === true ? 1 : 0), 0) > 20;
    },
    isMax30() {
      if (!this.columns) return false
      return Object.values(this.columns).reduce((acc, v) => acc + (v === true ? 1 : 0), 0) > 30;
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.adgroups = []
        this.getAllAdGroups()
        this.getReportAdgs();
      },
    },
    "page": {
      handler() {
        this.adgroups = [];
        this.getAllAdGroups();
      }
    },
    "accountsFilter": {
      handler() {
        this.adgroups = [];
        this.getAllAdGroups();
        this.getReportAdgs();
      },
    },
    "campaignsFilter": {
      handler() {
        this.adgroups = [];
        this.getAllAdGroups();
        this.getReportAdgs();
      },
    },
    "adGroupFilter": {
      handler(value) {
        if (value && value.length === 0) {
          this.adgroups.forEach(c => c.selected = false)
        }
        // this.adgroups = [];
        // this.getAllAdGroups();
        // this.getReportAdgs();
      },
    }
  },
  methods: {
    cleanAdgSelect() {
      this.$emit('cleanAdgSelect')
    },
    checkResource(name) {
      return (
        this.account &&
        this.account.resources &&
        this.account.resources.includes(name)
      );
    },
    syncScrools() {
      const campaignDiv = document.querySelector('.adgroups');
      const listItens = document.querySelector('.list-itens');
      const scrollContent = document.querySelector('.scrollbar-top .scroll-content');
      const topScrollbar = document.querySelector('.scrollbar-top');

      // Função para sincronizar o scroll
      function syncScrollbars() {
          // Sincronizar a rolagem
          topScrollbar.scrollLeft = campaignDiv.scrollLeft;

          // Ajustar a largura da barra de rolagem superior para ser a mesma que a do conteúdo
          scrollContent.style.width = listItens.scrollWidth + 'px';
          scrollContent.style.height = '10px';
      }

      //Adicionar evento de rolagem para sincronizar as barras
      campaignDiv.addEventListener('scroll', () => {
          topScrollbar.scrollLeft = campaignDiv.scrollLeft;
      });

      // Adicionar evento de rolagem para sincronizar as barras
      topScrollbar.addEventListener('scroll', () => {
        campaignDiv.scrollLeft = topScrollbar.scrollLeft;
      });

      // Sincronizar ao carregar a página e ao redimensionar a janela
      window.addEventListener('load', syncScrollbars);
      window.addEventListener('resize', syncScrollbars);
    },
    getValueC(attr, adgId) {
      if (!this.reportAdGroups[adgId]) {
        return 0
      }

      return this.reportAdGroups[adgId][attr]
    },
    getReportAdgs() {
      const date = this.filters && this.filters.data && this.filters.data.date;

      let params = {
          start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
          end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
          tracking: this.filters && this.filters.data.tracking,
      };
      getReportCampaigns(params)
        .then((result) => {
          this.reportAdGroups = result.adgroups

          this.stats = result.stats

        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    },
    changeSelectedAdg(adg) {
      if (adg.selected) {
        // adg selected
        this.$emit('adgSelected', adg.id)
      } else {
        // adg not selected
        this.$emit('adgRemoved', adg.id)
      }
    },
    showModalUpdateAdGroup(adGroup) {
      console.log('adGroup', adGroup)
    },
    getAllAdGroups() {
      this.loading = true
      const date = this.filters && this.filters.data && this.filters.data.date;
      let params = {
        page: this.page,
        offset: this.offset,
        campaigns: this.campaignsFilter && this.campaignsFilter.join(','),
        accounts: this.accountsFilter && this.accountsFilter.join(','),
        tracking: this.filters && this.filters.data.tracking,

      }
      if (date) {
        params = Object.assign(params, {
          start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
          end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        });
      }
      this.totalItens = 0

      Promise.all([
        getAdGroupsFacebook(params)
          .then((result) => {
            this.totalItens += result.total

            this.adgroups = this.adgroups.concat(result.adgroups.map((c) => {
              return { ...c, platform: "FBADS", selected: false, spend: 0, budget: 0 };
            }));

            this.adgroups.forEach(e => {
              if (this.adGroupFilter.includes(e.id) && e.platform === 'FBADS') {
                e.selected = true
              }
            });
          }),
        getAdGroupsGoogle(params)
        .then((result) => {
          this.totalItens += result.total

          this.adgroups = this.adgroups.concat(result.adgroups.map((c) => {
            return { ...c, platform: "GADS", selected: false, spend: 0, budget: 0 };
          }));

          this.adgroups.forEach(e => {
              if (this.adGroupFilter.includes(e.id) && e.platform === 'GADS') {
                e.selected = true
              }
            });
        })
      ])
      .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
          title: "Erro",
            message: "Falhou ao buscar Ad Groups",
          });
      })
      .finally(() => {
        this.loading = false;
      })
    },
    changeStatusAdGroup(adgroup){
      if (adgroup.platform === 'FBADS') {
        this.updateStatusFBADS(adgroup)
      } else if(adgroup.platform === 'GADS') {
        this.updateStatusGADS(adgroup)
      }

      this.showModalSwitchStatus = false;
      this.selectedAdGroup = null;
    },
    changeBulletAdGroup(adgroup){
      // console.log('adgroup', adgroup)
      if (adgroup.platform === 'FBADS') {
        this.updateBulletFBADS(adgroup)
      } else if(adgroup.platform === 'GADS') {
        this.updateBulletGADS(adgroup)
      }

      this.showUpdateModal = false;
      this.selectedAdGroup = null;
    },
    updateStatusFBADS(adgroup) {
      let params = {
          type: 'ADGROUP',
          id: adgroup.id,
          ad_account_id: adgroup.ad_account_id,
          status: adgroup.status,
      }

      updateStatusFBADS(params)
        .then((result) => {
          console.log('result', result)
          this.$toast.success({
            title:'Sucesso',
            message:'Campanha editada com sucesso'
          })
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    },
    updateStatusGADS(adgroup) {
      let params = {
          type: 'ADGROUP',
          id: adgroup.id,
          ad_account_id: adgroup.ad_account_id,
          status: adgroup.status,
      }

      updateStatusGADS(params)
        .then((result) => {
          console.log('result', result)
          this.$toast.success({
            title:'Sucesso',
            message:'Campanha editada com sucesso'
          })
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    },
    updateBulletFBADS(adgroup) {
      let params = {
          type: 'ADGROUP',
          id: adgroup.id,
          ad_account_id: adgroup.ad_account_id,
          bullet: adgroup.daily_budget,
      }

      updateBulletFBADS(params)
        .then((result) => {
          console.log('result', result)
          this.$toast.success({
            title:'Sucesso',
            message:'Campanha editada com sucesso'
          })
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    },
    updateBulletGADS(adgroup) {
      let params = {
          type: 'ADGROUP',
          id: adgroup.id,
          ad_account_id: adgroup.ad_account_id,
          bullet: adgroup.daily_budget,
      }

      updateBulletGADS(params)
        .then((result) => {
          console.log('result', result)
          this.$toast.success({
            title:'Sucesso',
            message:'Campanha editada com sucesso'
          })
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    },
  }
};
</script>

<style lang="scss" scoped>
.list-itens {
  width: 5000px;
  
  li {
    list-style-type: none;
    padding: 8px 4px;
    border-bottom: 1px solid #eee;
    font-size: 14px;
    min-height: 53px;

  }
}

.adgroups {
  overflow-x:scroll;
  width: 100%;

  .input {
    height: 36px;
    min-width: 140px;
    text-align: center;
  }
}

.fbads {
  color: blue;
}
.gads {
  color: red
}
.edit-money {
  padding: 8px !important;
  margin-left: 4px;
  border:0 px !important;
}
.input.input:disabled {
  color: var(--primary)
}
.lh-color {
  color: var(--terciary);
  font-weight: 800;
  background: #ededed;
  // border: 1px solid #c3c3c3;
  padding: 8px 4px;
  // border-radius: 5px;
  // margin-right: 4px;
}

.tag {
  background: #22222212;
  padding: 4px 8px;
  border-radius: 8px;
}

.negative {
  color: red;
}
.positive {
  color: green
}



.elem-name {
  width: 600px;
  position: absolute;
  background: var(--boxbg);
  height: 36px;
  padding-right: 20px;
  overflow-x: auto;
  z-index: 2;
  left: 0px;
  padding-left:24px;

  .name {
    padding-right: 8px;
  }
}

.elem-first-stats {
  margin-left: 700px;
}


/* Estilos básicos para a div principal */
.campaign-container {
  
}

/* Estilo para a barra de rolagem superior */
.scrollbar-top {
    overflow-x: auto;
    overflow-y: hidden;
    height: 20px; /* Tamanho da barra de rolagem */
    margin-bottom: 10px;

    .scroll-content {
      width: 5000px;
    }
}

/* Estilo para a div de conteúdo com classe campaign */
.adgroups {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    padding-bottom: 28px;
}

.lh-info {
  min-width: 840px;
}

.selected {
  background: #EDF2F4;
}

ul::-webkit-scrollbar {
  width: 10px !important;
  height: 25px !important;
}
ul::-webkit-scrollbar-thumb {
    background-color: #b12031;
    border-radius: 20px;
    border: 10px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
}

@media screen and (max-width: 1024px) {
  .elem-name {
    position: relative !important;
    width: 500px !important;
  }
  .elem-first-stats {
    margin-left: 0px !important;
  }
}

</style>
